import { type CustomTooltipProps } from "ag-grid-react"

import { leafVariantIds } from "~/components/planning/ProductTable/columns/cellHelpers"

import HeaderTooltip from "./HeaderTooltip"
import ReturnsGraph from "../../graphs/ReturnsGraph"

export default function ReturnsTooltip(props: CustomTooltipProps) {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }

  const variantIds = props.node?.group ? (leafVariantIds(props) ?? []) : [props.data.variantId]
  return (
    <div className="w-[600px] mr-6 z-10">
      <ReturnsGraph variantIds={variantIds} />
    </div>
  )
}
